//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// eslint-disable-next-line object-curly-newline
import { mdiSnowflake, mdiLeaf, mdiFire, mdiWater } from '@mdi/js'

export default {
  setup() {
    const seasons = ['Winter', 'Spring', 'Summer', 'Fall']
    const icons = [mdiSnowflake, mdiLeaf, mdiFire, mdiWater]

    const season = value => icons[value]

    return { seasons, icons, season }
  },
}
